import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4c0af786")

_pushScopeId("data-v-4c0af786")
const _hoisted_1 = { class: "card-body-currency" }
const _hoisted_2 = { class: "currency-add-btn" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle pr-20" }, null, -1)
const _hoisted_4 = { class: "currency-filter" }
const _hoisted_5 = { class: "currency-filter-date" }
const _hoisted_6 = { class: "currency-filter-title" }
const _hoisted_7 = { class: "calendar-block" }
const _hoisted_8 = { class: "p-relative mr-6" }
const _hoisted_9 = { class: "p-relative ml-6" }
const _hoisted_10 = { class: "currency-filter-currency" }
const _hoisted_11 = { class: "currency-filter-title" }
const _hoisted_12 = { class: "p-relative currency-select" }
const _hoisted_13 = { class: "search-button-wrapper" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_15 = { class: "currencies" }
const _hoisted_16 = { class: "currencies-header" }
const _hoisted_17 = { class: "currencies-header-date" }
const _hoisted_18 = { class: "currencies-header-currency" }
const _hoisted_19 = { class: "currencies-header-rate" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "currencies-header-empty" }, null, -1)
const _hoisted_21 = { class: "currency-item-date" }
const _hoisted_22 = { class: "currency-item-currency" }
const _hoisted_23 = { class: "currency-item-rate" }
const _hoisted_24 = {
  key: 0,
  class: "currency-item-edit text-r"
}
const _hoisted_25 = { class: "currency-showmore" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Multiselect = _resolveComponent("Multiselect")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ChangeRate(0)))
      }, [
        _hoisted_3,
        _createTextVNode(_toDisplayString(_ctx.$t('btn.add-rate')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('title.currency-filter-date')), 1),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_Calendar, {
              class: "calendar-width",
              maxDate: _ctx.toDate,
              modelValue: _ctx.fromDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.fromDate = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy",
              ref: "calendar"
            }, null, 8, ["maxDate", "modelValue"]),
            (_ctx.fromDate)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "icon-f icon-delete-cross fs-10",
                  style: {"color":"#adacb7"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fromDate = null))
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_Calendar, {
              class: "calendar-width",
              modelValue: _ctx.toDate,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.toDate = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy",
              minDate: _ctx.fromDate,
              ref: "calendar"
            }, null, 8, ["modelValue", "minDate"]),
            (_ctx.toDate)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "icon-f icon-delete-cross fs-10",
                  style: {"color":"#adacb7"},
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toDate = null))
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('title.currency')), 1),
        _createVNode("div", _hoisted_12, [
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.currencyId,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.currencyId = $event)),
            valueProp: "id",
            trackBy: "name",
            label: "symbol",
            options: _ctx.currencies,
            canDeselect: true,
            onChange: _ctx.currencyChanged
          }, null, 8, ["modelValue", "options", "onChange"]),
          (_ctx.currencyId)
            ? (_openBlock(), _createBlock("i", {
                key: 0,
                class: "icon-f icon-delete-cross fs-10",
                style: {"color":"#adacb7"},
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.currencyId = null))
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode("button", {
          type: "button",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getCurrRateByFilter()))
        }, [
          _hoisted_14
        ])
      ])
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode("div", _hoisted_16, [
        _createVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('title.currency-date')), 1),
        _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('title.currency-currency')), 1),
        _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('title.currency-rate')), 1),
        _hoisted_20
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getCurrencyRatesToShow, (currency, curIndex) => {
        return (_openBlock(), _createBlock("div", {
          class: "currency-item",
          key: curIndex
        }, [
          _createVNode("div", _hoisted_21, _toDisplayString(_ctx.getCurrDate(currency.startDate)), 1),
          _createVNode("div", _hoisted_22, _toDisplayString(currency.currency), 1),
          _createVNode("div", _hoisted_23, _toDisplayString(currency.rate), 1),
          (currency.currencyId != _ctx.localCurrencyId)
            ? (_openBlock(), _createBlock("div", _hoisted_24, [
                _createVNode("i", {
                  class: "icon-f icon-pencil-edit fs-16",
                  onClick: ($event: any) => (_ctx.ChangeRate(currency.id))
                }, null, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_25, [
      (_ctx.showSeeMore)
        ? (_openBlock(), _createBlock("span", {
            key: 0,
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getCurrRateByFilter()))
          }, "See more"))
        : _createCommentVNode("", true)
    ])
  ]))
})